<template>
  <DialogLogin
    v-if="hasDialogLogin"
    :dialog-visible="hasDialogLogin"
    @loginAfterHandle="handleAfterLoginAndInformationImproved"
    @closeDialog="
      () => {
        isDialog(false);
      }
    "
    :loginConfig="loginConfig"
  />
</template>

<script>
import { ABOUT_US, ENTERPRISE_PACKAGE, OLD_HOME } from "../../utils/constants/constants";
import DialogLogin from "./DialogLogin";
import { getLoginStatus, isValEmpty } from "../../utils/common";
import { OID_MAP } from "../../utils/constants/constants.track";
import {restHomepageLoginConfig} from "../../services/register";
export default {
  name: "LibDialogLogin",
  components: {
    DialogLogin,
  },
  props: {
    showLoginDialog: {
      type: Boolean,
      default: false,
    },
    loginSuccessGoData: {
      type: Object,
      default: () => {},
    },
    automaticImproveInformationDialog: { //是否自动弹 完事信息
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      OID_MAP,
      ENTERPRISE_PACKAGE,
      ABOUT_US,
      OLD_HOME,
      headerFixed: true,
      isEjected: "",
      scrollTop: 0,
      hasDialogLogin: false,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters["basic/isLogin"];
    },
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    isShowDialogLogin() {
      return this.$store.getters["basic/isShowDialogLogin"];
    },
    loginSuccessGo() {
      return this.$store.getters["basic/loginSuccessGo"];
    },
    isShowDialogInformationImprove() {
      return this.$store.getters["basic/isShowDialogInformationImprove"];
    },
    isShowDialogInformationImproveFrom() {
      return this.$store.getters["basic/isShowDialogInformationImproveFrom"];
    },
    isShowDialogInformationImproveConditions() {
      return {
        isLogin: this.$store.getters["basic/isLogin"],
        linkName: this.$store.getters["basic/userInfo"].linkName,
        dwmc: this.$store.getters["basic/userInfo"].dwmc,
        zhiwu: this.$store.getters["basic/userInfo"].zhiwu,
        roleId: this.$store.getters["basic/userInfo"].roleId,
      };
    },
    loginConfig() {
      return this.$store.getters["basic/loginConfig"];
    },
  },
  watch: {
    isShowDialogInformationImproveConditions: {
      //完善信息页
      handler(newV = {}) {
        const { linkName, dwmc, zhiwu, roleId } = newV;
        const isRegister = sessionStorage.getItem("onRegister");
        if (isRegister) {
          sessionStorage.removeItem("onRegister");
        }
        if (newV.isLogin && !isRegister&&this.automaticImproveInformationDialog) {
          // 用户登录后判断三有信息且是主账号
          if ((!linkName || !dwmc || !zhiwu) && roleId === 1) {
            // 三有信息不完善
            setTimeout(() => {
              this.$store.commit("basic/updateIsShowDialogLogin", true);
              this.$store.commit("basic/updateIsShowDialogInformationImprove", true); // 显示完善信息弹窗
              this.$store.commit("basic/updateIsShowDialogInformationImproveFrom", "afterPageLoad"); // 显示完善信息弹窗展示来源
            }, 200);
          }
        }
      },
      deep: true,
      immediate: true,
    },
    showLoginDialog: {
      handler(type) {
        this.$store.commit("basic/updateIsShowDialogLogin", type);
      },
      deep: true,
      immediate: true,
    },
    isShowDialogLogin: {
      handler(type) {
        if (type && getLoginStatus() && !this.isShowDialogInformationImprove) {
          //登录后继续打开登录弹框，自动刷新页面登录态
          window.location.reload();
          return;
        }
        this.hasDialogLogin = type;
      },
      deep: true,
    },
    loginSuccessGoData: {
      handler(val) {
        if (!isValEmpty(val)) {
          this.$store.commit("basic/updateLoginSuccessGo", val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    if( isValEmpty(this.updateLoginConfig)){
      this.homepageLoginConfig()
    }
  },
  mounted() {},
  methods: {
    async homepageLoginConfig() {
      try {
        const data = await restHomepageLoginConfig();
        this.$store.commit("basic/updateLoginConfig", data.data);
      } catch (e) {
        console.error(e);
      }
    },
    isDialog(type) {
      this.$store.commit("basic/updateIsShowDialogLogin", type);
      this.$emit("isDialog", type);
    },
    handleAfterLoginAndInformationImproved() {
      console.log(this.loginSuccessGo, "this.loginSuccessGothis.loginSuccessGo");
      if (this.loginSuccessGo.type === "open") {
        window.open(this.loginSuccessGo.url, "_target");
        location.reload(); //登录后应该是刷新当前页
      } else if (this.loginSuccessGo.type === "href") {
        if (this.loginSuccessGo.url) {
          window.location.href = this.loginSuccessGo.url;
        } else {
          window.location.reload();
        }
      } else {
        window.location.reload();
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
